export default __webpack_public_path__ + "static/media/test-env-dark.c06e6ba9.png";